import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar/index';
import React from 'react';
import styled from 'styled-components';

import Icon from '../Icon';

const HeaderToolbar = ( { title, page, toggleMenu, Search, withDrawer = true } ) => {
    const StyledHeaderToolbar = styled(Toolbar)`
       &.stolo-header-toolbar {
            position: relative;
            background-color: transparent;
            ${props => props.theme.typography.display1};
            display: flex;
            align-items: center;
            padding-left: 2px;
            padding-right: 1.31em;
            justify-content: space-between;
            min-height: ${props => props.theme.space[12]};
            height: ${props => props.theme.space[12]};
            width: 100%;
       }
        
        & .stolo-logo {
          height: ${props => props.theme.space[15]};
          fill: ${props => props.theme.palette.secondary[700]};
        }
        
        & .stolo-homewrapper {
          width: fit-content;
        }
        
        & .stolo-icon-cart {
           width: ${props => props.theme.space[15]};
           padding-top: 3px;
        }
    `;

    const HeaderLeft = styled.div`
        position: relative;
        left: 0px;
        display: flex;

        & .menu-title {
          color: white;
          font-size: 0.85em;
          margin-left: 0.5em;
          margin-bottom: 1px;
        }

        & .outlined {
          border: 1px solid rgba(255, 255, 255, 0.8);
        }

        & .nav-menu {
          padding: 2px 10px;
          min-height: 24px;
        }
    `;

    const HeaderCenter = styled.div`
        flex-grow: 1;
        margin: 0 auto;
        text-align: center;
        padding-right: 4em;
        font-size: 1.1rem;
        color: ${props => props.theme.palette.common.white};
    `;

    const DrawerMenuIcon = () =>
        <HeaderLeft>
            <Button
                color='inherit'
                aria-label='open drawer'
                onClick={toggleMenu}
                className='nav-menu'
                variant='outlined'
                classes={{ outlined: 'outlined' }}
            >
                <Icon
                    className='schnoffle-dense-icon'
                    name='icon-dehaze'
                    height='1.5rem'
                    width='1.5rem'
                    iconColor='common.white'
                />
                <span className='menu-title'>Menü</span>
            </Button>
        </HeaderLeft>;

    const HeaderSearch = () => {
        if (!Search) {
            return null;
        }
        return (
            <Search/>
        );
    };

    return (
        <React.Fragment>
            <StyledHeaderToolbar
                role='banner'
                classes={{ root: 'stolo-header-toolbar' }}
            >
                {withDrawer ? <DrawerMenuIcon/> : null}
                <HeaderCenter>
                    {title}
                </HeaderCenter>
            </StyledHeaderToolbar>
            <HeaderSearch/>
        </React.Fragment>
    );
};

export default HeaderToolbar;



// WEBPACK FOOTER //
// ./src/components/header/HeaderToolbar.js